
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/attr.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-registry-attr-demo-attrs-x-align","docs-api-registry-attr-demo-attrs-text-wrap","docs-api-registry-attr-demo-attrs-text-anchor"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/attr.en.md?type=demo')
};